import "./App.css";

import AppRoutes from "./Routes/Routes";

function App() {
  return (
    <div className="app">
      <AppRoutes />
    </div>
  );
}

export default App;
